// extracted by mini-css-extract-plugin
export default {"paginado":"Paginado_paginado__9MgAt"};